import {
  ROOT,
  GET_EMAIL_TYPE,
  UPDATE_EMAIL_TYPE,
  DETAIL_EMAIL,
  UPDATE_EMAIL,
  EMAIL_TEST,
  GET_TEAMPLATE,
  DETAIL_CONFIG_HEADER_FOOTER,
  UPDATE_CONFIG_HEADER_FOOTER,
} from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";
function getEmailType() {
  return fetch(ROOT + GET_EMAIL_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateEmailType(body) {
  return fetch(ROOT + UPDATE_EMAIL_TYPE + `/${body}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detailEmail() {
  return fetch(ROOT + DETAIL_EMAIL, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateEmail(body) {
  return fetch(ROOT + UPDATE_EMAIL, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function apiTestEmail(body) {
  return fetch(ROOT + EMAIL_TEST, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getTemplate(id) {
  return fetch(ROOT + GET_TEAMPLATE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detail(id) {
  return fetch(ROOT + DETAIL_CONFIG_HEADER_FOOTER + `?id=${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(body) {
  return fetch(ROOT + UPDATE_CONFIG_HEADER_FOOTER, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const configBeService = {
  getEmailType,
  updateEmailType,
  detailEmail,
  updateEmail,
  apiTestEmail,
  getTemplate,
  detail,
  update
};
